import { useQuery } from '@tanstack/react-query';
import { profilerApi } from '@/api/profiler';
import type { CDDReport } from '@/types/profiler';

export function useEDDPoller(caseId: string | undefined) {
  const query = useQuery<CDDReport>({
    queryKey: ['edd-case', caseId],
    queryFn: () => profilerApi.getCase(caseId!),
    enabled: !!caseId,
    refetchInterval: (query) => {
      const data = query.state.data;
      const err  = query.state.error as Error | null;
      if (err?.name === 'AuthError') return false;
      if (!data) return 3_000;
      if (data.status === 'COMPLETE' || data.status === 'FAILED') return false;
      return 5_000;
    },
    retry: (failureCount, error) => {
      if ((error as Error)?.name === 'AuthError') return false;
      return failureCount < 2;
    },
    staleTime: 0,
  });

  return {
    ...query,
    sessionExpired: (query.error as Error)?.name === 'AuthError',
  };
}
